import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Steps,
  Tag,
  Space,
  Typography,
  Row,
  Col,
  Modal,
  Divider,
  App,
  Card,
  Spin,
} from "antd";
import {
  MailOutlined,
  LinkedinOutlined,
  PlusOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  SendOutlined,
  ClearOutlined,
  LoadingOutlined,
  CloseOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import { Modal as BootModal} from "react-bootstrap";
import countrycode from "../../utility/countrycode.json";
import Hexapi from "../../utility/HexAPI/Hexapi";
import FormField from "../../component/fields/Inputbox";
import { showConfirm } from "../../utility/showconfirm";
import STEPSdata from "./steps";
import ResumeUploadParser from "./ResumeUploadParser";
import "./customer.css"
import Urlencoder from "../../utility/Urluncoder";
import { Aesdecryption } from "../../utility/Aes/Aes";
const { Title, Text } = Typography;
const { Option } = Select;
const INITIAL_FORM = {
  fullname: "",
  dob: null,
  gender: undefined,
  nationality: "Indian",
  currentaddress: "",
  email: "",
  countrycodecontact: "+91",
  contactnumber: "",
  countrycodealt: "+91",
  alternateno: "",
  linkedin: "",
  currentdesignation: "",
  currentcompany: "",
  totalexperience: undefined,
  noticeperiod: "",
  currentctc: "",
  expectedctc: "",
  qualification: undefined,
  stream: "",
  institute: "",
  passingyear: "",
  appliedposition: "",
  department: undefined,
  source: undefined,
  referredby: "",
  priority: "",
  StageID: 2,
  remarks: "",
  subsource:""
};

const STEPS = STEPSdata;

export default function CustomerEnquiryform({
  editid,
  open,
  onClose,
  refreshtableadd,
}) {
  console.log("open","opennnnn")
  const [form] = Form.useForm();

  const isModal = typeof open === "boolean";
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [agentID,setagentID]=useState(null)
  const [activeSection, setActiveSection] = useState(0);
  const [skills, setSkills] = useState([]);
  const [skillInput, setSkillInput] = useState("");
  const [resumeFile, setResumeFile] = useState(null);
  const [isresume, setisresume] = useState(false);
  const [resumerequired,setresumerequired]=useState(true)
  const [formData, setFormData] = useState({
    stage: [],
    skillname: [],
    qualification: [],
    department: [],
    source: [],
    experience: [],
    appliedpositionfor: [],
    aiconfig:[]
  });
  const [resumeUploading, setResumeUploading] = useState(false);
  const [formDataLoading, setFormDataLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [resumeSummary,setresumeSummary]=useState("")
  const [resumedataai,setresumedataai]=useState(null)
  const [disabledFields, setDisabledFields] = useState({
    source: false,
    appliedposition: false,
  })
  const [ExistingResumeId,setExistingResumeId]=useState(null)
const decodeUrl = async (url) => {
  try {
    const parts = url.split("?");

    let finalUrl = url;

    if (parts[1]) {
      const decrypted = Aesdecryption(parts[1]);

      if (decrypted) {
        const dectext = `?${btoa(decrypted)}`;
        finalUrl = parts[0] + "/" + dectext;
      }
    }

    const decodedData = await Urlencoder(finalUrl);

    return decodedData; 
  } catch (err) {
    console.error("decodeUrl error:", err);
    return null;
  }
};

useEffect(() => {
  const loadData = async () => {
    const res = await decodeUrl(window.location.href);

    console.log(res, "decoded url response");

    if (res?.agentID) {
      setagentID(res.agentID);
    }

    if(res?.sourceid){
      form.setFieldValue("source", Number(res.sourceid))
      setDisabledFields((prev) => ({ ...prev, source: true }));
    }else{
        setDisabledFields((prev) => ({ ...prev, source: false }));
    }

    if(res?.appliedposition){
      form.setFieldValue("appliedposition", Number(res.appliedposition))
      setDisabledFields((prev) => ({ ...prev, appliedposition: true }));
    }else{
        setDisabledFields((prev) => ({ ...prev, appliedposition: false }));
    }
  };

  loadData();
}, []);
  useEffect(() => {
    if (resumeFile) setisresume(false);
  }, [resumeFile]);

  const addSkill = (skillObj) => {
    if (!skillObj) {
      const trimmed = skillInput.trim();
      if (!trimmed || skills.find((s) => s.label === trimmed)) return;

      setSkills((prev) => [...prev, { recid: null, label: trimmed }]);
      setSkillInput("");
      return;
    }

    if (skills.find((s) => s.label === skillObj.label)) return;
    setSkills((prev) => [...prev, skillObj]);
  };

  const validateStep = async (stepIndex) => {
    const fieldMap = {
      0: [],
      1: ["fullname", "email", "contactnumber"],
      2: [],
      3: ["appliedposition", "source", "StageID"],
    };

    try {
      await form.validateFields(fieldMap[stepIndex] || []);
      return true;
    } catch {
      return false;
    }
  };

  // const GetEditformData = async () => {
  //   if (!agentID || !editid) return;
  
  //   try {
  //     const obj = {
  //       query: `HCMS_Proc_EditCandidate_getFormData @agentID='{0}',@CandidateID='{1}'`,
  //       queryArr: [`${agentID}`, `${editid}`],
  //     };
  
  //     const resp = await Hexapi(obj);
  
  //     const raw = resp?.[""]?.[0];
  
  //     console.log(raw, "raw");
  
  //     if (!raw) return;

      

  //     const findIdByLabel = (list, value) => {
  //       if (!value) return undefined;
  //       const item = list?.find(
  //         (x) =>
  //           x.label?.toString().trim().toLowerCase() ===
  //           value?.toString().trim().toLowerCase()
  //       );
  
  //       return item?.recid;
  //     };
  
  //     const mapped = {
  //       fullname: raw.fullname || "",
  //       dob: raw?.dob?.date ? dayjs(raw.dob?.date) : null,
  //       gender: raw.gender ?? undefined,
  //       nationality: raw.nationality || "Indian",
  //       currentaddress: raw.currentaddress || "",
  //       email: raw.email || "",
  //       countrycodecontact: raw.countrycode || "+91",
  //       contactnumber: raw.phonenumber || "",
  //       countrycodealt: "+91",
  //       alternateno: raw.alternatenumber || "",
  
  //       linkedin: raw.linkedin || "",
  
  //       currentdesignation: raw.currentdesignation || "",
  
  //       currentcompany: raw.currentcompany || "",
  
       
  //       totalexperience: raw.totalexperience || undefined,
  
  //       noticeperiod: raw.noticeperiod || "",
  
  //       currentctc: raw.currentctc || "",
  
  //       expectedctc: raw.expectedctc || "",
  
  //       qualification: raw.qualification || undefined,
  
  //       stream: raw.stream || "",
  
  //       institute: raw.institute || "",
  
  //       passingyear: raw.passingyear || "",
  
       
  //       appliedposition: raw.appliedposition
  //         ? findIdByLabel(
  //             formData.appliedpositionfor,
  //             raw.appliedposition
  //           )
  //         : undefined,
  
  //       department:
  //         raw.departmentid == 0
  //           ? undefined
  //           : raw.departmentid,
  
  //       source: raw.leadsourceid || undefined,
  
  //       referredby: raw.referredby || "",
  
  //       priority: raw.priority || "",
  
  //       StageID: raw.stageid || undefined,
  
  //       remarks: raw.remarks || "",
  //     };
  
  //     setTimeout(() => {
  //       form.setFieldsValue(mapped);
  //     }, 0);
  
  //     console.log(raw.skills,"skillsssssss")
  //  if (raw.skills) {
  //   const skillArr = raw.skills
  //     .split(",")
  //     .map((s) => s.trim())
  //     .filter(Boolean);
  
  //   const mappedSkills = skillArr.map((skillId) => {
  //     const found = formData.skillname.find(
  //       (x) => String(x.recid) === String(skillId)
  //     );
  
  //     return found
  //       ? {
  //           recid: found.recid,
  //           label: found.label,
  //         }
  //       : {
  //           recid: skillId,
  //           label: skillId,
  //         };
  //   });
  
  //   setSkills(mappedSkills);
  //   console.log(raw?.resumeid,"resumeiddddddd")
  //  const resumeId = raw?.resumeid?.trim();
  // console.log(resumeId,"resumeId")
  
  // if (resumeId && resumeId != null  && raw?.filename != null) {
  //   setisresume(true);
  //   setResumeFile({
  //     name:`${raw?.filename}`
  //   })
  //   setExistingResumeId(resumeId);
  //   setisresumevalue(true);
  // }else{
  //   setisresume(false)
  //   setExistingResumeId(null)
  // }
  // }
      
     
  //   } catch (error) {
  //     console.error("GetEditformData error:", error);
  //   }
  // };
  
  // useEffect(() => {
  //   if (
  //     candidateID &&
  //     formData.skillname.length > 0
  //   ) {
  //     GetEditformData();
  //   }
  // }, [candidateID, formData]);
const goNext = async () => {
  if (activeSection === 0 && resumerequired) {

    // upload/parsing chal raha hai
    if (resumeUploading) {
      Modal.warning({
        title: "Please wait",
        centered: true,
        content: "Resume is still uploading/parsing...",
      });

      return;
    }

    // resume hi nahi hai
    if (!resumeFile) {
      setisresume(true);

      Modal.error({
        title: "Resume Required",
        centered: true,
        content: "Please upload resume / CV before going to next step.",
      });

      return;
    }
  }

  const valid = await validateStep(activeSection);
  if (valid) {
    setActiveSection((s) => Math.min(s + 1, STEPS.length - 1));
  }
};

  const goBack = () => {
    setActiveSection((s) => Math.max(s - 1, 0));
  };

  const getformData = async () => {
    try {
      setFormDataLoading(true);

      const obj = {
        query: `[dbo].[HCMS_Proc_Candidate_Add_getFormData] @AgentID='{0}'`,
        queryArr: [`${agentID}`],
      };

      const resp = await Hexapi(obj);
console.log(resp,"resp")
      if (resp) {
        setFormData({
          skillname: resp.skillname || [],
          qualification: resp.qualification || [],
          source: resp.source || [],
          experience: resp.experience || [],
          appliedpositionfor: resp?.appliedpositionfor || [],
          aiconfig:resp.aiconfig
        });
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setFormDataLoading(false);
    }
  };
  const Logsubmit=async(InputTokens,OutputTokens,totaltime,Answer,MODEL_ID)=>{
  const stats=`in-${InputTokens}out-${OutputTokens}-Totalthinkingtime-${totaltime}`
try {
  const obj={
    query:`[dbo].[HCMS_Proc_OCR_Log_Submit]
    @AgentID='{0}',
    @ModalName='{1}',
    @InputTokens='{2}',
    @OutputTokens='{3}',
    @Stats='{4}',
    @Answer='{5}',
    @targetedFor='{6}',
    @Imagetokens='{7}'
    `,
    queryArr:[`${agentID}`,`${MODEL_ID}`,`${InputTokens}`,`${OutputTokens}`,`${stats}`,`${Answer}`,"Resume Summarization",0]
  }
  
  const resp = await Hexapi(obj)
} catch (error) {
  console.log("Logging failed", error);
}
}
const handleSummarize = async (appliedID) => {
  const selectedPosition = formData?.appliedpositionfor?.find(
    (x) => String(x.recid || x.RecID) === String(appliedID)
  );

  console.log(selectedPosition, "selectedPosition");
  console.log(resumedataai, "resumedataai");

  const systemprompt = selectedPosition?.prompt || selectedPosition?.Prompt || "";

  const userprompt = `
Applied Position:
${selectedPosition?.label || selectedPosition?.AppliedPositionFor || ""}

Candidate Resume Data:
${JSON.stringify(resumedataai, null, 2)}
`;

  if (!formData?.aiconfig || formData.aiconfig.length === 0) return;

  const aiconfigdata = formData?.aiconfig?.[1];

  const startTime = Date.now();

  try {
    const geminiUrl = aiconfigdata?.baseurl

    const response = await fetch(`${geminiUrl}?key=${aiconfigdata?.apikey}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        contents: [
          {
            role: "user",
            parts: [{ text: userprompt }],
          },
        ],
        systemInstruction: {
          parts: [{ text: systemprompt }],
        },
        generationConfig: {
          maxOutputTokens: Math.floor(Number(aiconfigdata?.maxtokens)) || 2048,
          temperature: 0.4,
        },
      }),
    });

    if (!response.ok) {
      let errorMsg = `Error ${response.status}`;

      try {
        const errData = await response.json();
        errorMsg = errData?.error?.message || errorMsg;
      } catch {}

      console.log(errorMsg, "Gemini error");
      return "";
    }

    const parsed = await response.json();

    const finalText =
      parsed?.candidates?.[0]?.content?.parts
        ?.map((p) => p.text || "")
        .join("") || "";

    const inputTokens = parsed?.usageMetadata?.promptTokenCount || 0;
    const outputTokens = parsed?.usageMetadata?.candidatesTokenCount || 0;

    const totalSeconds = ((Date.now() - startTime) / 1000).toFixed(2);

    console.log(finalText, "finalText");
    console.log({
      inputTokens,
      outputTokens,
      totalTokens: inputTokens + outputTokens,
      totalSeconds,
    });

    setresumeSummary(finalText);
await Logsubmit(inputTokens,outputTokens,totalSeconds,finalText,aiconfigdata?.modelname)
    return finalText;
  } catch (err) {
    console.log(err, "handleSummarize error");
    return "";
  }
};
  useEffect(() => {
    if (agentID) getformData();
  }, [agentID]);

  const getresumeid = async (file) => {
    if (!file) return null;

    const extension = "." + /[^.]+$/g.exec(file.name)[0];

    const obj = {
      query: `[dbo].[HCMS_Proc_Add_Attachment]@AgentID='{0}',@Extension='{1}',@FileName='{2}',@Attachment=$%$File$%$`,
      queryArr: [`${agentID}`, `${extension}`, `${file.name}`],
      file,
    };

    const resp = await Hexapi(obj);
    return resp?.[""]?.[0]?.attachmentid || null;
  };

  const getdesignation = async (desing) => {
    try {
      if (!desing) return null;

      if (!isNaN(desing) && String(desing).trim() !== "") {
        return Number(desing);
      }

      const value = String(desing).trim();

      const matched = formData?.appliedpositionfor?.find(
        (x) =>
          String(x.AppliedPositionFor || x.appliedpositionfor || x.label || "")
            .trim()
            .toLowerCase() == value.toLowerCase()
      );
      if (matched) return matched.recid || matched.recid || matched.value;
      const obj = {
        query: `[dbo].[HCMS_Proc_Add_Designation] @AppliedPositionFor='{0}'`,
        queryArr: [value],
      };

      const resp = await Hexapi(obj);
      const data = resp?.[""]?.[0];

      if (data?.command === 1) return data?.RecID || data?.recid;

      return null;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const skillsadd = async (skillsdata = []) => {
    try {
      const oldSkillIds = skillsdata.filter((s) => s.recid).map((s) => s.recid);

      const newSkills = skillsdata
        .filter((s) => !s.recid && s.label)
        .map((s) => s.label.trim());

      const uniqueSkills = [...new Set(newSkills)];

      let newSkillIds = [];

      if (uniqueSkills.length) {
        const obj = {
          query: `[dbo].[HCMS_Proc_Add_Skills] @SkillNames='{0}'`,
          queryArr: [uniqueSkills.join(",")],
        };

        const resp = await Hexapi(obj);
        newSkillIds = resp?.[""]?.map((x) => x.recid) || [];
      }

      return [...oldSkillIds, ...newSkillIds];
    } catch (error) {
      console.log(error);
      return [];
    }
  };

  const handleSubmit = async () => {
    try {
     const sourceLower = selectedSourceLabel?.trim()?.toLowerCase();

const allStepFields = {
  1: ["fullname", "email", "contactnumber"],
  3: [
    "appliedposition",
    "source",
    "StageID",
    ...(sourceLower === "referral" ? ["referredby"] : []),
    ...(sourceLower === "other" ? ["subsource"] : []),
  ],
};

      const stepErrors = [];

      if (!resumeFile) {
        setisresume(true);

        stepErrors.push({
          stepIndex: 0,
          stepTitle: "Resume Upload",
          errors: ["Please upload resume / CV"],
        });
      }

      for (const [stepIndex, fields] of Object.entries(allStepFields)) {
        try {
          await form.validateFields(fields);
        } catch (errorInfo) {
          const errors = errorInfo.errorFields
            ?.map((f) => f.errors?.[0])
            .filter(Boolean);

          if (errors?.length > 0) {
            stepErrors.push({
              stepIndex: Number(stepIndex),
              stepTitle:
                STEPS[Number(stepIndex)]?.title ||
                `Step ${Number(stepIndex) + 1}`,
              errors,
            });
          }
        }
      }

      if (stepErrors.length > 0) {
        Modal.error({
          title: "Please fix the following errors before submitting",
          centered: true,
          content: (
            <div>
              {stepErrors.map(({ stepTitle, errors }) => (
                <div key={stepTitle} style={{ marginBottom: 12 }}>
                  <Text strong style={{ color: "#ff4d4f" }}>
                    📌 {stepTitle}
                  </Text>

                  <ul style={{ marginTop: 5, paddingLeft: 20 }}>
                    {errors.map((err, i) => (
                      <li key={i}>{err}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ),
          onOk: () => setActiveSection(stepErrors[0].stepIndex),
        });

        return;
      }

      setSubmitLoading(true);
      const values = form.getFieldsValue(true);
      const designationId = await getdesignation(values.appliedposition);
      const skillIds = await skillsadd(skills);
      const resumeid = await getresumeid(resumeFile);
      const resumesummary = await handleSummarize(values.appliedposition)
      const obj = {
        query: `[dbo].[HCMS_Proc_Add_Candidate]
    @AgentID='{0}', @FullName='{1}', @DOB='{2}', @Gender='{3}', @Nationality='{4}',
    @CurrentAddress='{5}', @Email='{6}', @CountryCode='{7}', @ContactNumber='{8}',
    @AlternateNumber='{9}', @LinkedIn='{10}', @CurrentDesignation='{11}',
    @CurrentCompany='{12}', @TotalExperience='{13}', @NoticePeriod='{14}',
    @CurrentCTC='{15}', @ExpectedCTC='{16}', @Qualification='{17}', @Stream='{18}',
    @Institute='{19}', @PassingYear='{20}', @AppliedPosition='{21}',
    @subsource='{22}', @Source='{23}', @ReferredBy='{24}',
     @Remarks='{25}', @Skills='{26}', @ResumeID='{27}',@ResumeSummary='{28}'`,
        queryArr: [
          `${agentID}`,
          `${values.fullname || ""}`,
          `${values.dob ? values.dob.format("YYYY-MM-DD") : ""}`,
          `${values.gender || ""}`,
          `${values.nationality || "Indian"}`,
          `${values.currentaddress || ""}`,
          `${values.email || ""}`,
          `${values.countrycodecontact || "+91"}`,
          `${values.contactnumber || ""}`,
          `${values.alternateno || ""}`,
          `${values.linkedin || ""}`,
          `${values.currentdesignation || ""}`,
          `${values.currentcompany || ""}`,
          `${values.totalexperience || ""}`,
          `${values.noticeperiod || ""}`,
          `${values.currentctc || 0}`,
          `${values.expectedctc || 0}`,
          `${values.qualification || ""}`,
          `${values.stream || ""}`,
          `${values.institute || ""}`,
          `${values.passingyear || ""}`,
          `${values.appliedposition || ""}`,
          `${values.subsource || ""}`,
          `${values.source || ""}`,
          `${values.referredby || ""}`,
          `${values.remarks || ""}`,
          `${skillIds.join(",") || ""}`,
          `${resumeid || ""}`,
          `${resumeSummary}`
          ,
        ],
      };

      const result = await Hexapi(obj)

      if (result?.[""]?.[0]) {
        showConfirm({
          content: result[""][0].msg,
          okText: "OK",
        });

        if (result[""][0].command == 0) return;

        form.resetFields();
        setSkills([]);
        setResumeFile(null);
        setisresume(false);
        setActiveSection(0);

        refreshtableadd?.();

        if (isModal) onClose?.();
      }
    } catch (err) {
      console.log(err, "submit error");
    } finally {
      setSubmitLoading(false);
    }
  };

  const handleReset = () => {
    Modal.confirm({
      title: "Reset form?",
      content: "All entered data will be cleared.",
      okText: "Yes, Reset",
      cancelText: "Cancel",
      centered: true,
      onOk: () => {
        form.resetFields();
        setSkills([]);
        setResumeFile(null);
        setisresume(false);
        setActiveSection(0);
      },
    });
  };

  const handleClose = () => {
    form.resetFields();
    setSkills([]);
    setResumeFile(null);
    setisresume(false);
    setActiveSection(0);
    onClose?.();
  };

  const PhoneAddon = (fieldName) => (
    <Form.Item name={fieldName} noStyle initialValue="+91">
      <Select
        style={{ width: isMobile ? 85 : 110 }}
        showSearch
        optionFilterProp="children"
      >
        {countrycode.map((c) => (
          <Option key={c.dial_code} value={c.dial_code}>
            {c.dial_code}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );

  const selectedSource = Form.useWatch("source", form);

  const selectedSourceLabel = formData.source
    ?.find((x) => x.recid == selectedSource)
    ?.label?.toLowerCase();

 const FormContent = (
  <div className="candidate-form-layout">
    <Card
      className="candidate-header-card"
      style={{
        flexShrink: 0,
        borderRadius: isModal ? 0 : 12,
        borderLeft: isModal ? "none" : undefined,
        borderRight: isModal ? "none" : undefined,
        borderTop: isModal ? "none" : undefined,
      }}
    >
      <Row
        justify="space-between"
        align="middle"
        gutter={[8, 8]}
        className="candidate-header-row"
      >
        <Col xs={14} sm={6}>
          <div className="candidate-title-box">
            <Title level={isMobile ? 5 : 4} className="candidate-main-title">
              Apply For Job
            </Title>

            <p className="candidate-sub-title">
              At Hex Business Innovation
            </p>
          </div>
        </Col>

        <Col xs={10} sm={6}>
          <Space wrap className="candidate-header-actions">
            <Button
              className="candidate-submit-btn"
              style={{ background: "#AD0000", color: "white" }}
              icon={submitLoading ? <LoadingOutlined /> : <SendOutlined />}
              onClick={handleSubmit}
              loading={submitLoading}
              disabled={formDataLoading}
            >
              Submit
            </Button>

            {isModal && (
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={handleClose}
                className="candidate-close-btn"
              />
            )}
          </Space>
        </Col>
      </Row>
    </Card>

    <Card
      className="candidate-steps-card"
      style={{
        flexShrink: 0,
        borderRadius: isModal ? 0 : 12,
        borderLeft: isModal ? "none" : undefined,
        borderRight: isModal ? "none" : undefined,
        marginTop: isModal ? 0 : 12,
      }}
    >
      <Steps
        current={activeSection}
        direction="horizontal"
        responsive={false}
        size="small"
        className="job-mobile-steps"
        onChange={(nextStep) => {
          if (activeSection === 0 && nextStep > 0 && resumerequired) {
            if (resumeUploading) {
              Modal.warning({
                title: "Please wait",
                centered: true,
                content: "Resume is still uploading/parsing...",
              });
              return;
            }

            if (!resumeFile) {
              setisresume(true);

              Modal.error({
                title: "Resume Required",
                centered: true,
                content: "Please upload resume / CV before going to next step.",
              });

              return;
            }
          }

          setActiveSection(nextStep);
        }}
        items={STEPS.map((s, index) => ({
          title: isMobile ? `${index + 1}` : s.title,
          status:
            index < activeSection
              ? "finish"
              : index === activeSection
              ? "process"
              : "wait",
          icon:
            index < activeSection ? (
              <CheckCircleFilled style={{ color: "#52c41a" }} />
            ) : (
              s.icon
            ),
        }))}
      />
    </Card>

    <div className="candidate-scroll-body">
      <Spin
        spinning={formDataLoading}
        tip="Loading form data..."
        indicator={<LoadingOutlined style={{ fontSize: 32 }} spin />}
      >
        <Card className="candidate-form-card">
          <Form
            preserve={true}
            form={form}
            layout="vertical"
            initialValues={INITIAL_FORM}
            requiredMark="optional"
          >
            <div style={{ display: activeSection === 0 ? "block" : "none" }}>
              <Title level={5} className="candidate-section-title">
                Resume Upload
              </Title>
              <Text type="secondary" className="candidate-section-subtitle">
                Upload resume / CV to continue
              </Text>
              <Divider className="candidate-divider" />

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={16} md={6}>
                  <ResumeUploadParser
                   setresumedataai={setresumedataai}
                    setresumerequired={setresumerequired}
                    formData={formData}
                    form={form}
                    agentID={agentID}
                    setSkills={setSkills}
                    resumeFile={resumeFile}
                    setResumeFile={setResumeFile}
                    isresume={isresume}
                    setResumeUploading={setResumeUploading}
                  />
                </Col>
              </Row>
            </div>

            <div style={{ display: activeSection === 1 ? "block" : "none" }}>
              <Title level={5} className="candidate-section-title">
                Personal Information
              </Title>
              <Text type="secondary" className="candidate-section-subtitle">
                Basic identity details of the candidate
              </Text>
              <Divider className="candidate-divider" />

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={6}>
                  <FormField name="fullname" label="Full Name" required placeholder="Enter full name" />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField name="nationality" label="Nationality" placeholder="e.g. Indian" />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField
                    placeholder="Select gender"
                    name="gender"
                    label="Gender"
                    type="select"
                    options={["Male", "Female", "Other"]}
                  />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField
                    name="email"
                    label="Email ID"
                    type="email"
                    required
                    prefix={<MailOutlined />}
                    placeholder="name@example.com"
                  />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField name="dob" label="Date of Birth" type="date" />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField
                    name="linkedin"
                    label="LinkedIn Profile"
                    prefix={<LinkedinOutlined />}
                    placeholder="https://linkedin.com/in/..."
                  />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label={
                      <>
                        Contact Number{" "}
                        <span style={{ color: "#ff0000b0", marginLeft: 3 }}>*</span>
                      </>
                    }
                    name="contactnumber"
                    required
                    rules={[
                      { required: true, message: "Contact number is required" },
                      { len: 10, message: "Must be exactly 10 digits" },
                      { pattern: /^[0-9]+$/, message: "Numbers only" },
                    ]}
                  >
                    <Input
                      addonBefore={PhoneAddon("countrycodecontact")}
                      placeholder="10-digit number"
                      maxLength={10}
                      size="large"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <Form.Item
                    label="Alternate Number"
                    name="alternateno"
                    rules={[
                      {
                        pattern: /^[0-9]{0,10}$/,
                        message: "Numbers only, max 10 digits",
                      },
                    ]}
                  >
                    <Input
                      addonBefore={PhoneAddon("countrycodealt")}
                      placeholder="Optional"
                      maxLength={10}
                      size="large"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={16} md={16}>
                  <FormField
                    name="currentaddress"
                    label="Current Address"
                    placeholder="Street, City, State, PIN"
                  />
                </Col>
              </Row>
            </div>

            <div style={{ display: activeSection === 2 ? "block" : "none" }}>
              <Title level={5} className="candidate-section-title">
                Professional Details
              </Title>
              <Text type="secondary" className="candidate-section-subtitle">
                Work history and compensation details
              </Text>
              <Divider className="candidate-divider" />

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12} md={6}>
                  <FormField
                    name="qualification"
                    label="Highest Qualification"
                    type="select"
                    options={formData.qualification.map((q) => ({
                      value: q.recid,
                      label: q.label,
                    }))}
                  />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField name="stream" label="Specialisation / Stream" placeholder="e.g. Computer Science" />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField name="institute" label="Institute / University" placeholder="e.g. Delhi University" />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField
                    name="passingyear"
                    label="Passing Year"
                    placeholder="e.g. 2020"
                    maxLength={4}
                    rules={[{ pattern: /^[0-9]{0,4}$/, message: "Enter valid year" }]}
                  />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField name="currentcompany" label="Current / Last Company" placeholder="e.g. Infosys Ltd." />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField
                    name="totalexperience"
                    label="Total Experience"
                    type="select"
                    options={formData.experience.map((e) => ({
                      value: e.recid,
                      label: e.label,
                    }))}
                  />
                </Col>

                <Col xs={24} sm={12} md={6}>
                  <FormField
                    name="noticeperiod"
                    label="Notice Period"
                    type="select"
                    options={["Immediate", "15 days", "30 days", "60 days", "90 days"]}
                  />
                </Col>

                <Col xs={24} sm={6} md={6}>
                  <FormField name="currentctc" label="Current CTC (₹ LPA)" placeholder="e.g. 8.5" />
                </Col>
                 <Col xs={24} sm={6}>
                                        <FormField name="expectedctc" label="Expected CTC (₹ LPA)" placeholder="e.g. 12" />
                                      </Col>
              </Row>
            </div>

            <div style={{ display: activeSection === 3 ? "block" : "none" }}>
              <Title level={4} className="candidate-section-title">
                Application Details
              </Title>
              <Text type="secondary" className="candidate-section-subtitle">
                Role applied for and recruitment metadata
              </Text>
              <Divider className="candidate-divider" />

              <Row gutter={[16, 0]}>
                <Col xs={24} sm={12}>
                  <FormField
                    required
                    disabled={disabledFields.appliedposition}
                    type="select"
                    name="appliedposition"
                    label="Applied for Position"
                    options={formData.appliedpositionfor.map((s) => ({
                      value: s.recid,
                      label: s.label,
                    }))}
                  />
                </Col>

                <Col xs={24} sm={12}>
                  <p className="candidate-field-label">Skills</p>

                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Search and select skills..."
                    size="large"
                    className="candidate-skills-select"
                    value={skills.map((s) => s.label)}
                    filterOption={(input, option) =>
                      option?.label?.toLowerCase().includes(input.toLowerCase())
                    }
                    onChange={(selectedLabels) => {
                      const updated = selectedLabels.map((label) => {
                        const existing = skills.find((s) => s.label === label);
                        if (existing) return existing;

                        const fromBackend = formData.skillname.find((s) => s.label === label);
                        return fromBackend || { recid: null, label };
                      });

                      setSkills(updated);
                    }}
                    options={formData.skillname.map((s) => ({
                      value: s.label,
                      label: s.label,
                    }))}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: "8px 0" }} />

                        <div style={{ padding: "4px 8px 8px" }}>
                          <Text type="secondary" style={{ fontSize: 12 }}>
                            Can't find your skill? Type and press Enter to add custom
                          </Text>

                          <Space.Compact style={{ width: "100%", marginTop: 6 }}>
                            <Input
                              placeholder="Type custom skill..."
                              value={skillInput}
                              size="middle"
                              onChange={(e) => setSkillInput(e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  e.preventDefault();
                                  e.stopPropagation();
                                  addSkill();
                                }
                              }}
                            />

                            <Button type="primary" icon={<PlusOutlined />} onClick={() => addSkill()}>
                              Add
                            </Button>
                          </Space.Compact>
                        </div>
                      </>
                    )}
                    tagRender={(props) => {
                      const { label, closable, onClose } = props;

                      return (
                        <Tag
                          color="blue"
                          closable={closable}
                          onClose={onClose}
                          style={{
                            marginInlineEnd: 4,
                            padding: "2px 8px",
                            fontSize: 13,
                          }}
                        >
                          {label}
                        </Tag>
                      );
                    }}
                    notFoundContent={
                      <div style={{ textAlign: "center", padding: "12px 0", color: "#999" }}>
                        No skills found. Add custom below ↓
                      </div>
                    }
                  />
                </Col>

                <Col xs={24} sm={12}>
                  <FormField
                  disabled={disabledFields.source}
                    required
                    name="source"
                    label="How did you find out about us?"
                    type="select"
                    options={formData.source.map((s) => ({
                      value: s.recid,
                      label: s.label,
                    }))}
                  />
                </Col>

      {selectedSourceLabel === "referral" && (
  <Col xs={24} sm={12}>
   <FormField
                    required
                    name="referredby"
                    label="Referral Name"
                    type="text"
     
                  />
  
  </Col>
)}

{selectedSourceLabel === "other" && (
  <Col xs={24} sm={12}>
    <FormField
                    required
                    name="subsource"
                    label="Other Source"
                    type="text"
                    placeholder="Enter source details"
      
 />
  </Col>
)}
              </Row>
            </div>
          </Form>
        </Card>
      </Spin>
    </div>

    <div className="candidate-footer">
      <div>
        {activeSection > 0 && (
          <Button
            className="candidate-footer-btn"
            icon={<ArrowLeftOutlined />}
            onClick={goBack}
            disabled={submitLoading}
          >
            Back
          </Button>
        )}
      </div>

      <div>
        {activeSection < STEPS.length - 1 && (
          <Button
            className="candidate-footer-btn"
            type="primary"
            iconPosition="end"
            icon={<ArrowRightOutlined />}
            onClick={goNext}
            disabled={formDataLoading || submitLoading}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  </div>
);

  return (
    <App>
      {isModal ? (
          <BootModal
          show={open}            
          onHide={handleClose}
          fullscreen={true}
          centered={!isMobile}
        
          backdrop="static"
          keyboard={false}
          contentClassName="p-0 border-0"
          dialogClassName={isMobile ? "" : "modal-90w"}
        >
          <BootModal.Body
            className="p-0"
            style={{
              height: isMobile ? "100dvh" : "90vh",
              maxHeight: isMobile ? "100dvh" : "90vh",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {FormContent}
          </BootModal.Body>
        </BootModal>
      ) : (
        <div
          style={{
            width: "100%",
            height: isMobile ? "100dvh" : "100vh",
            padding: isMobile ? "10px" : "20px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              maxWidth: "1400px",
              margin: "0 auto",
              height: "100%",
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
            }}
          >
            {FormContent}
          </div>
        </div>
      )}
    </App>
  );
}